<template>
  <!-- Site Total -->
  <VisitorDwellTotal
    v-if="time?.name === 'Total'"
    :area="area"
    :zone="zone"
    :widget="widget"
  />

  <!-- Site/Zone Daily -->
  <VisitorDwellDaily
    v-if="time?.name === 'Day'"
    :area="area"
    :zone="zone"
    :widget="widget"
  />
</template>

<script setup lang="ts">
import type { WidgetTypeEngagedVisitorDwell, WidgetFilter, WidgetSetting } from '@/types/Widget';

import VisitorDwellTotal from './VisitorDwellTotal.vue';
import VisitorDwellDaily from './VisitorDwellDaily.vue';

defineProps<{
  widget: WidgetTypeEngagedVisitorDwell,
  area?: WidgetFilter,
  time?: WidgetFilter,
  zone?: WidgetSetting,
  cluster?: WidgetSetting,
}>()

</script>
